import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { CheckCircle, XCircle } from 'lucide-react';
export function QualificationSection() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <section className="relative py-16 sm:py-20 md:py-24 px-5 sm:px-6 bg-stone-950" data-id="element-2843" data-mp="1cj1chrfaojta">
      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 30
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-5xl mx-auto" data-id="element-2844" data-mp="1cgx1yqmw4mk1">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-center text-stone-100 mb-12 sm:mb-16" style={{
        fontFamily: 'Cinzel, serif'
      }} data-id="element-2845" data-mp="208c86uhsfo0k">
          Is This Right For You?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12" data-id="element-2846" data-mp="otfe366qy8mc">
          {/* Who this is for */}
          <div data-id="element-2847" data-mp="kqiq0zyftkb0">
            <h3 className="text-xl sm:text-2xl font-bold text-green-400 mb-6 flex items-center gap-3" data-id="element-2848" data-mp="kq0llg1mfzs0">
              <CheckCircle className="w-6 h-6 sm:w-8 sm:h-8" data-id="element-2849" data-mp="1mnmro9jfk7pv" />
              This IS For You If:
            </h3>
            <ul className="space-y-4 sm:space-y-6" data-id="element-2850" data-mp="1rletbv9vn879">
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-2851" data-mp="1dn6s3b5t5kqa">
                <div className="w-1.5 h-1.5 bg-green-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-2852" data-mp="1hnh71dbkvlha" />
                <span data-id="element-2853" data-mp="13w3r09cvp5r0">
                  You are a medical professional, coach, or serious biohacker
                  who wants to operate at the cutting edge.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-2854" data-mp="tyy0b286fgrb">
                <div className="w-1.5 h-1.5 bg-green-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-2855" data-mp="yx99daqndn8h" />
                <span data-id="element-2856" data-mp="kxzucee6gz63">
                  You understand that true mastery requires deep study and
                  ongoing education.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-2857" data-mp="pyx88es5n71s">
                <div className="w-1.5 h-1.5 bg-green-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-2858" data-mp="2rnbda9zr73j5" />
                <span data-id="element-2859" data-mp="2mtyzyw0iyj5p">
                  You want to be able to solve complex health puzzles that leave
                  others stumped.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-2860" data-mp="2dvwotnn2ua4p">
                <div className="w-1.5 h-1.5 bg-green-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-2861" data-mp="3ajtav81a9xnb" />
                <span data-id="element-2862" data-mp="35muhwstcvwqp">
                  You value scientific validation and evidence-based protocols
                  over hype.
                </span>
              </li>
            </ul>
          </div>

          {/* Who this is NOT for */}
          <div data-id="element-2863" data-mp="2wn7czx1f48sw">
            <h3 className="text-xl sm:text-2xl font-bold text-red-400 mb-6 flex items-center gap-3" data-id="element-2864" data-mp="1q51234xha54b">
              <XCircle className="w-6 h-6 sm:w-8 sm:h-8" data-id="element-2865" data-mp="1l5xy7nt8i4xx" />
              This Is NOT For You If:
            </h3>
            <ul className="space-y-4 sm:space-y-6" data-id="element-2866" data-mp="o5fl41fpf9y">
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-2867" data-mp="pqef5us7kdm">
                <div className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-2868" data-mp="5ni2tpw7wod2" />
                <span data-id="element-2869" data-mp="9nscpdn4ryx7">
                  You are looking for a "magic pill" that requires no effort or
                  understanding.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-2870" data-mp="jf6ext6gvcu1">
                <div className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-2871" data-mp="ocyftcp3a9ad" />
                <span data-id="element-2872" data-mp="tc1dgc2qpd8b">
                  You are not willing to invest time in learning the
                  foundational principles.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-2873" data-mp="xbtm0os4vjdo">
                <div className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-2874" data-mp="2v6aeql0wq1qp" />
                <span data-id="element-2875" data-mp="2z7lvs25ptena">
                  You are satisfied with mainstream, surface-level health
                  advice.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-2876" data-mp="1zspth5ip9sfs">
                <div className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-2877" data-mp="2dshbrig91uzl" />
                <span data-id="element-2878" data-mp="28u60r4e7xefs">
                  You want quick hacks rather than deep, sustainable biological
                  optimization.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </motion.div>
    </section>;
}